import React from 'react';

import SectionMessage from '@atlaskit/section-message';

export default function TestCaseExecutionStatusSectionMessage(): JSX.Element {
  return (
    <SectionMessage title='Use advanced status types for more accurate reporting'>
      <p>
        {`You're currently not using advanced status types. Unlock more accurate reporting with "Failed" status type - listing all failed executions
        accordingly, and "Passed" status type - helping in reporting finished executions.`}
      </p>
    </SectionMessage>
  );
}
